export default [
  {
    acronym: 'EFG %',
    term: 'Effective Field Goal %',
    meaning:
      'EFG is an adjusted look at field goal percentage that accounts for the value of the shot attempt. Basically, shooting 40% from 3 is not the same as 40% from 2 and EFG reflects the additional value gained from 3 point shooting.',
    formula: '(fgm + (0.5 * fgm3)) / fga',
  },
  {
    acronym: 'ORR',
    term: 'Offensive Rebound Rate',
    meaning:
      'ORR is a metric that tracks of the percentage of offensive rebounds rather than the raw number. If Team A misses 50 shots in a game and 35 in the next, counting the raw number of rebounds is misleading and provides much less value than counting the percentage of rebounds.',
    formula: 'oreb / (oreb + opp_dreb)',
  },
  {
    acronym: 'FTR',
    term: 'Free Throw Rate',
    meaning:
      "FTR is the ratio of free throws made to field goals attempted and demonstrates a team's ability to not only draw fouls and get to the line but also convert on those attempts.",
    formula: 'ftm / fga',
  },
  {
    acronym: 'TOV',
    term: 'Turnover Percentage',
    meaning:
      'TOV is a metric that shows what percentage of possessions end in a turnover. Winning the turnover battle is key but just counting turnovers does not always tell the whole story. Also, it allows us to compare the turnovers of teams with different paces of play.',
    formula: 'to / (fga + 0.44 * fta + to)',
  },
  {
    attr: 'total_games',
    term: 'Games',
    meaning: 'Number of games played',
    acronym: 'GMS',
  },
  {
    attr: 'total_factored_points_poss',
    term: 'Offensive Rating',
    meaning: 'Points scored per 100 possessions',
    acronym: 'ORTG',
  },
  {
    attr: 'total_factored_opp_points_poss',
    term: 'Defensive Rating',
    meaning: 'Points allowed per 100 possessions',
    acronym: 'DRTG',
  },
  {
    attr: 'total_factored_net_rating',
    term: 'Net Rating',
    meaning: 'Net points per 100 possessions',
    acronym: 'NET',
  },
  {
    attr: 'pp40',
    term: 'Pace',
    meaning: 'Expected number of possessions per 40 minutes',
    acronym: 'PACE',
  },
  {
    attr: 'efg',
    term: 'EFG',
    meaning:
      'Effective Field Goal Percentage is a weighted field goal percentage that accounts for the increased value of the three point shot',
    acronym: 'EFG',
  },
  {
    attr: 'tov',
    term: 'TOV',
    meaning:
      'Turnover rate is the percentage of all possessions that end in a turnover',
    acronym: 'TOV',
  },
  {
    attr: 'orr',
    term: 'ORR',
    meaning:
      'Offensive Rebound Rate is the percentage of all missed shots are rebounded by the offensive team',
    acronym: 'ORR',
  },
  {
    attr: 'ftr',
    term: 'FTR',
    meaning:
      'Free Throw Rate is calculated FTM/FGA and shows the contribution of free throws to overall scoring',
    acronym: 'FTR',
  },
  {
    attr: 'atr_rate',
    term: 'Rim Attempt Rate',
    meaning:
      'Percentage of all field goal attempts that occur at or around the rim',
    acronym: 'ATRAR',
  },
  {
    attr: 'atr_percentage',
    term: 'Rim %',
    meaning:
      'Shooting percentage on field goal attempts that occur at or around the rim',
    acronym: 'ATR%',
  },
  {
    attr: 'three_rate',
    term: '3 Attempt Rate',
    meaning: 'Percentage of all field goal attempts that are from three',
    acronym: '3PAR',
  },
  {
    attr: 'three_percentage',
    term: '3FG%',
    meaning: 'Shooting percentage on all three point field goal attempts',
    acronym: '3FG%',
  },
  {
    attr: 'mid_rate',
    term: 'Mid Attempt Rate',
    meaning:
      'Percentage of all field goal attempts that are from two point range but DO NOT occur at or around the rim',
    acronym: 'MIDAR',
  },
  {
    attr: 'mid_percentage',
    term: 'Mid %',
    meaning:
      'Shooting percentage on all two point field goal attempts that DO NOT occur at or around the rim',
    acronym: 'MID%',
  },
  {
    attr: 'pps',
    term: 'PPS',
    meaning:
      'Points per shot with FTM included. This is an equivavlent to True Shooting as it adds points created from three point shooting and free throws made.',
    acronym: 'PPS+FT',
  },
  {
    attr: 'pps_noft',
    term: 'PPS NO FT',
    meaning:
      'Points per shot WITHOUT FTM included. This is an equivalent to EFG as it adds points created from three point shooting BUT NOT free throws made.',
    acronym: 'PPS',
  },
  {
    attr: 'true_shooting',
    term: 'TS%',
    meaning:
      'True shooting percentage is a weighted field goal percentage that accounts for the increased value of the three point shot and the ability to draw fouls and convert at the line',
    acronym: 'TS%',
  },
  {
    attr: 'fg_perc',
    term: 'FG%',
    meaning: 'Field Goal Percentage',
    acronym: 'FG%',
  },
  {
    attr: 'fg2_perc',
    term: '2FG%',
    meaning: 'Field Goal Percentage on two point field goal attempts',
    acronym: '2FG%',
  },
  {
    attr: 'ft_perc',
    term: 'FT%',
    meaning: 'Free Throw Percentage',
    acronym: 'FT%',
  },
  {
    attr: 'assist_percentage',
    term: 'Assist %',
    meaning: 'Percentage of FGM that are assisted',
    acronym: 'AST%',
  },
  {
    attr: 'ato',
    term: 'ATO',
    meaning: 'Assist to Turnover Ratio',
    acronym: 'ATO',
  },
];
